function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.65,0C9.6,0,8.35,3.13,8.35,4.93V8.35h7V9H4.93C2.64,9,0,10.85,0,16s2.64,7,4.93,7H9V18.78A2.8,2.8,0,0,1,11.83,16h8.34a2,2,0,0,0,2.09-2.09v-9C22.26,2.5,20,0,15.65,0ZM12.52,3.48a1.39,1.39,0,1,1-1.39,1.39A1.39,1.39,0,0,1,12.52,3.48ZM23,9v4.87a2.8,2.8,0,0,1-2.79,2.79H11.83a2,2,0,0,0-2.09,2.08v8.29C9.74,29.5,12,32,16.35,32c6,0,7.3-3.12,7.3-4.93V23.65H16.7V23H27.07C29.36,23,32,21.15,32,16s-2.64-7-4.93-7Zm-3.48,16.7a1.39,1.39,0,1,1-1.39,1.39A1.39,1.39,0,0,1,19.48,25.74Z",
    id: "path1082",
    style: {
      fill: "#6600ff",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.6920638a2bcd7ac5108286d397746eca.svg";
export { ForwardRef as ReactComponent };